import { useEffect } from "react";
import CClipboard from "../components/CClipboard";
import ChatCollapse from "../components/ChatCollapse";
import { AppIssueContextProvider } from "../context/appIssueContext";

declare global {
  interface Window {
    jQuery: any;
  }
}

function show() {
  window.jQuery("#sidebarCollapse span:nth-child(3)").toggleClass("w-50");
  window.jQuery(".idocs-navigation").toggleClass("active");
}

export default function Home() {
  useEffect(() => {
    const anchor = window.location.hash.slice(1);
    if (anchor) {
      const anchorEl = window.document.getElementById(anchor);
      if (anchorEl) {
        anchorEl.scrollIntoView();
      }
    }
  }, []);

  return (
    <>
      <header id="header" className="sticky-top">
        <nav className="primary-menu navbar navbar-expand-lg navbar-dropdown-dark">
          <div className="container-fluid">
            <button id="sidebarCollapse" onClick={show} className="navbar-toggler d-block d-md-none" type="button">
              <span></span>
              <span className="w-75"></span>
              <span className="w-50"></span>
            </button>

            <a className="logo ml-md-3" href="/" title="React-reex">
              {" "}
              <img src="assets/images/logo.png" width={40} alt="iDocs Template" />
              <span className="text-5 ml-2 mono-font">React-reex</span>
            </a>

            <div id="header-nav" className="collapse navbar-collapse justify-content-end">
              <ul className="navbar-nav"></ul>
            </div>
            <ul className="social-icons social-icons-sm ml-lg-2 mr-2">
              <li className="social-icons-github">
                <a data-toggle="tooltip" href="#" target="_blank" title="" data-original-title="Github">
                  <i className="fab fa-github"></i>
                </a>
              </li>
              <li className="social-icons-dribbble">
                <a data-toggle="tooltip" href="#" target="_blank" title="" data-original-title="Dribbble">
                  <i className="fab fa-dribbble"></i>
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </header>

      <div id="content" role="main">
        <div className="idocs-navigation bg-light">
          <ul className="nav flex-column ">
            <li className="nav-item">
              <a className="nav-link active" href="#start">
                Getting Started
              </a>
              <ul className="nav flex-column">
                <li className="nav-item">
                  <a className="nav-link" href="#start">
                    What is React-reex ?
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#installation">
                    Installation
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#configuration">
                    Configuration
                  </a>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#core_concepts">
                Core concepts
              </a>
              <ul className="nav flex-column">
                <li className="nav-item">
                  <a className="nav-link" href="#state">
                    State
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#getters">
                    Getters
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#actions">
                    Actions
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#mutations">
                    Mutations
                  </a>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#hooks_utils">
                Hooks and utils
              </a>
              <ul className="nav flex-column">
                <li className="nav-item">
                  <a className="nav-link" href="#use_reex_module">
                    useReexModule
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#use_mounted">
                    useMounted
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#use_fetch">
                    useFetch
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#reset_store">
                    resetStore
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#get_getter">
                    getGetter
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#get_state">
                    getState
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#use_reex_action">
                    useReexAction
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#subscribe">
                    subscribe
                  </a>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#store_persistent">
                Store Persistent
              </a>
              <ul className="nav flex-column">
                <li className="nav-item">
                  <a className="nav-link" href="#store_persistent_all">
                    All stores
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#store_persistent_specific">
                    Specific store
                  </a>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#structure">
                Folder structure proposition
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#issues">
                Issues
              </a>
            </li>
            {/* <li className="nav-item">
              <a className="nav-link" href="#idocs_source_credits">
                Source & Credits
              </a>
            </li> */}
          </ul>
        </div>

        <div className="idocs-content">
          <div className="container">
            <section id="start">
              <h1>Documentation</h1>
              <h2 id="react-reex">React-reex</h2>
              <p>
                <strong>
                  <em>React-reex</em>
                </strong>{" "}
                is a lightweight global state management solution for React and React-native. It depends on React and
                doesn&#39;t use <em>React Context API</em> but only based on <strong>useState</strong> hook
              </p>
            </section>

            <hr className="divider" />

            <section id="installation">
              <h3 id="1-installation">1. Installation</h3>
              <h5 id="a-yarn">a. YARN</h5>
              <CClipboard className="lang-bash">yarn add react-reex@latest</CClipboard>
              <h5 id="b-npm">b. NPM</h5>
              <CClipboard className="lang-bash">npm install react-reex@latest --save</CClipboard>
            </section>

            <hr className="divider" />

            <section id="configuration">
              <h3 id="2-configuration">2. Configuration</h3>
              <p>You must to do the configuration below if you need to use it as global store.</p>
              <h5 id="a-createmodule">a. CreateModule</h5>
              <p>
                In{" "}
                <em>
                  <code>/store/counter/index.ts</code>
                </em>
              </p>
              <CClipboard>
                {`import { createModule } from "react-reex"

const counterStore = createModule({
  name: "counter",
  state() {
    return {
      count: 0,
    }
  },
  getters: {
    double() {
      return this.count * 2
    },
  },
  actions: {
    increment() {
      this.commit("setCount", this.count + 1)
    },
    decrement(v: number) {
      this.count--
    },
  },
  mutations: {
    setCount(value: number) {
      this.count = value
    },
  },
  events: {
    count: {
      handler(value) {
        console.log("Count has changed", value)
      },
    },
  },
})

export default counterStore`}
              </CClipboard>
              <h5 id="b-createstore">b. CreateStore</h5>
              <p>
                In{" "}
                <em>
                  <code>/store/index.ts</code>
                </em>
              </p>
              <CClipboard className="lang-typescript">
                {`import { createStore } from "react-reex"
import counterStore from "./counter"

const store = createStore({
  modules: {
    counterStore,
  },
  created() {
    console.log("created global")
  },
  before(data) {
    console.log("before global", data)
  },
  handler(state) {
    console.log("handler global", state)
  },
})

export const { useReexState, useReexGetter, useReexModule, useReexAction } = store

export default store`}
              </CClipboard>
              <h5 id="c-import-store-folder-in-application-main">c. Create a component</h5>
              <p>
                In{" "}
                <em>
                  <code>/components/MyComponent.tsx</code>
                </em>
              </p>
              <CClipboard className="lang-typescript">
                {`import React from "react"
import store, { useReexState } from "../store"

const Counter = () => {
  const count = useReexState("counter/count")

  return (
    <button
      onClick={() => store.dispatch("counter/increment")}
    >
      {count}
    </button>
  )
}`}
              </CClipboard>

              <h5 id="c-import-store-folder-in-application-main">d. Import store folder in application main</h5>
              <p>
                In{" "}
                <em>
                  <code>App.tsx</code>
                </em>
              </p>
              <CClipboard className="lang-typescript">
                {`import React from "react"

import "../store" // Add this

export default function App() {
  return <>{/* Your application code */}</>
}`}
              </CClipboard>
            </section>

            <hr className="divider" />

            <section id="core_concepts">
              <h2>Core concepts</h2>
              <p className="lead mb-5">Documentation and examples for state, getters, actions, mutations</p>
            </section>

            <section id="state">
              <h3 id="3-states">3. State</h3>
              <p>
                Use <code>useReexState()</code> hook to access your current state&#39;s values. Below is an example of
                store that we will use.
              </p>
              <CClipboard className="lang-typescript">
                {`import { createModule } from "react-reex"

const counterStore = createModule({
  state() {
    return {
      count: 0,
    }
  },
})

export default counterStore`}
              </CClipboard>
              <h5 id="usereexstate">useReexState</h5>
              <p>
                The states are used with the <code>useReexState()</code> hook. Your component will be notified only of
                the change connected to your states.
              </p>
              <ul>
                <li>
                  <strong>
                    <em>reactjs</em>
                  </strong>
                </li>
              </ul>
              <CClipboard className="lang-typescript">
                {`import React from "react"
import { useReexState } from "../store"

const Counter = () => {
  const count = useReexState("counter/count")

  return <span>{count}</span>
}`}
              </CClipboard>
              <ul>
                <li>
                  <strong>
                    <em>react-native</em>
                  </strong>
                </li>
              </ul>
              <CClipboard className="lang-typescript">
                {`import React from "react"
import { Text } from "react-native"
import { useReexState } from "../store"

const Counter = () => {
  const count = useReexState("counter/count")

  return <Text>{count}</Text>
}`}
              </CClipboard>
            </section>

            <hr className="divider" />

            <section id="getters">
              <h3 id="4-getters">4. Getters</h3>
              <p>
                Use <code>useReexGetter()</code> hook to access your current state&#39;s values. You can also use
                getters for computed logic. Below is an example of store that we will use.
              </p>
              <CClipboard className="lang-typescript">
                {`import { createModule } from "react-reex"

const counterStore = createModule({
  name: "counter",
  state() {
    return {
      count: 0,
    }
  },
  getters: {
    double() {
      return this.count * 2
    },
  },
  actions: {
    ...
  },
  mutations: {
    ...
  },
  events: {
    ...
  },
})

export default counterStore`}
              </CClipboard>
              <h5 id="usereexgetter">useReexGetter</h5>
              <p>
                The getters are used with the <code>useReexGetter()</code> hook. Your component will be notified only of
                the change connected to your getters.
              </p>
              <ul>
                <li>
                  <strong>
                    <em>reactjs</em>
                  </strong>
                </li>
              </ul>
              <pre>
                <code className="lang-typescript">
                  {`import React from "react"
import { useReexGetter } from "../store"

const Counter = () => {
  const double = useReexGetter("counter/double")

  return <span>{double}</span>
}`}
                </code>
              </pre>
              <ul>
                <li>
                  <strong>
                    <em>react-native</em>
                  </strong>
                </li>
              </ul>
              <CClipboard className="lang-typescript">
                {`import React, { useEffect } from "react"
import { Text } from "react-native"
import { useReexGetter } from "../store"

const Counter = () => {
  const double = useReexGetter("counter/double")

  return <Text>{double}</Text>
}`}
              </CClipboard>
            </section>

            <hr className="divider" />

            <section id="actions">
              <h3 id="5-actions">5. Actions</h3>
              <p>
                Use actions for asynchronous data operations, for example REST API calls. The{" "}
                <strong>
                  <code>this</code>
                </strong>{" "}
                scope is an object with five keys:
              </p>
              <h5 id="a-use-dispatch-in-a-store">a. Use dispatch in a store</h5>
              <ul>
                <li>
                  <strong>state</strong>: this is the current state of the current store
                </li>
                <li>
                  <strong>dispatch</strong>: to call another action that&#39;s dependent on your current action&#39;s
                  data and to alter the current state.
                </li>
                <li>
                  <strong>getState</strong>: to get any state in the current store or another
                </li>
                <li>
                  <strong>getGetter</strong>: to get any getter in the current store or another
                </li>
                <li>
                  <strong>commit</strong>: to call any mutation in the current store or another
                </li>
              </ul>
              <CClipboard className="lang-typescript">
                {`import { createModule } from "react-reex"

const counterStore = createModule({
  state() {
    return {
      count: 0,
    }
  },
  getters: {
    double() {
      return this.count * 2
    },
  },
  actions: {
    increment() {
      this.commit("setCount", 1)
    },
    incr() {
      this.dispatch("increment")
    },
  },
  mutations: {
    setCount(value) {
      this.count = value
    },
  },
})

export default counterStore`}
              </CClipboard>
              <h5 id="b-use-dispatch-in-a-component">b. Use dispatch in a component</h5>
              <p>
                To use an action in a component, use the <code>dispatch()</code>. Actions always return a promise. They
                don&#39;t get re-created, so you&#39;re safe with using them as dependencies for <em>useEffect</em> or{" "}
                <em>useCallback</em>.
              </p>
              <CClipboard className="lang-typescript">
                {`import React, { useEffect } from "react"
import store from "../store"

const Counter = () => {
  useEffect(() => {
    store.dispatch("counter/increment")
  }, [])

  return <></>
}`}
              </CClipboard>
            </section>

            <hr className="divider" />

            <section id="mutations">
              <h3 id="6-mutations">6. Mutations</h3>
              <p>
                Use mutations to change your current state&#39;s values. Mutations are synchronous operations and can be
                called with the <code>commit()</code> or inside an action.
              </p>
              <h5 id="a-declare-mutation-in-a-store">a. Declare mutation in a store</h5>
              <p>Below is an example of store that we will use.</p>

              <CClipboard className="lang-typescript">
                {`import { createModule } from "react-reex"

const counterStore = createModule({
  state() {
    return {
      posts: [],
    }
  },
  ...
  mutations: {
    setPosts(data) {
      this.posts = data
    },
    addPost(data) {
      this.posts = [...this.posts, data]
    },
    deletePostByIndex(index) {
      this.posts = this.posts.filter((p, i) => i !== index)
    },
  },
})

export default counterStore`}
              </CClipboard>
              <h5 id="b-use-commit-in-a-component">b. Use commit in a component</h5>
              <p>
                To use a mutation in a component, use the <code>commit()</code>.
              </p>
              <ul>
                <li>
                  <strong>
                    <em>reactjs</em>
                  </strong>
                </li>
              </ul>
              <CClipboard className="lang-typescript">
                {`import React from "react"
import store from "../store"

const PostComponent = () => {
  const handlePostAdd = () => {
    store.commit("counter/addPost", {
      id: 1,
      title: "New post to be added",
      body: "Awesome text inside",
    })
  }

  return <button onClick={handlePostAdd}>Add new post</button>
}`}
              </CClipboard>
              <ul>
                <li>
                  <strong>
                    <em>react-native</em>
                  </strong>
                </li>
              </ul>
              <CClipboard className="lang-typescript">
                {`import React from "react"
import { Button } from "react-native"
import store from "../store"

const PostComponent = () => {
  const handlePostAdd = () => {
    store.commit("counter/addPost", {
      id: 1,
      title: "New post to be added",
      body: "Awesome text inside",
    })
  }

  return <Button onPress={handlePostAdd} title='Add new post' color='#841584' />
}`}
              </CClipboard>
            </section>

            <hr className="divider" />

            <section id="hooks_utils">
              <h3 id="7-hooks-and-utils">7. Hooks and utils</h3>
              <section id="use_reex_module">
                <h5 id="a-usereexmodule">a. useReexModule</h5>
                <ul>
                  <li>
                    <strong>
                      <em>
                        <code>useReexModule</code> as custom hooks
                      </em>
                    </strong>
                  </li>
                </ul>
                <CClipboard className="lang-typescript">
                  {`import { createModule } from "react-reex"

const counterStore = createModule({
  name: "counter",
  state() {
    return {
      count: 0,
    }
  },
  getters: {
    double() {
      return this.count * 2
    },
  },
  actions: {
    ...
  },
  mutations: {
    ...
  },
  events: {
    ...
  },
})

export default counterStore`}
                </CClipboard>

                <CClipboard>
                  {`import { useReexModule } from "../store"

function CounterComponent() {
  const { state } = useReexModule('counter')

  return (
    <div>{state.count}</div>
  )
}`}
                </CClipboard>
              </section>

              <hr className="divider" />

              <section id="use_mounted">
                <h5 id="b-usemounted">b. useMounted</h5>

                <CClipboard className="lang-typescript">
                  {`import React from "react"
import { useMounted } from "react-reex"

function MyComponent() {
  useMounted(() => {
    console.log("Component mounted")
  })

  return <></>
}`}
                </CClipboard>
              </section>

              <hr className="divider" />

              <section id="use_fetch">
                <h5 id="c-usefetch">c. useFetch</h5>

                <CClipboard className="lang-typescript">
                  {`import React, { useEffect } from "react"
import { useFetch } from "react-reex"

function CButton() {
  const fetch = useCallback(async function () {
    return {
      message: "done",
    }
  }, [])

  const { fetcher, loading, data } = useFetch(fetch)

  useEffect(() => {
    console.log(loading)
  }, [loading])

  return <button onClick={fetcher}>RUN</button>
}`}
                </CClipboard>
              </section>

              <hr className="divider" />

              <section id="reset_store">
                <h5 id="d-resetstore">d. resetStore</h5>
                <p>
                  use <code>resetStore</code> function to reset all store
                </p>
                <p>
                  <em>reactjs</em>
                </p>
                <CClipboard className="lang-typescript">
                  {`import React, { useCallback } from "react"
import { resetStore } from "react-reex"

function MyComponent() {
  const reset = useCallback(() => {
    resetStore()
  }, [resetStore])

  return <button onClick={reset}>Reset store</button>
}`}
                </CClipboard>
                <p>
                  <em>react-native</em>
                </p>
                <CClipboard className="lang-typescript">
                  {`import React, { useCallback } from "react"
import { resetStore } from "react-reex"

function MyComponent() {
  const reset = useCallback(() => {
    resetStore()
  }, [resetStore])

  return <Button onPress={reset} title='Reset store' />
}`}
                </CClipboard>
              </section>

              <hr className="divider" />

              <section id="get_getter">
                <h5 id="e-getgetter">e. getGetter</h5>

                <CClipboard className="lang-typescript">
                  {`import { useEffect } from "react"
import store from "../store"

function MyComponent() {
  useEffect(() => {
    const double = store.getGetter("counter/double")
    console.log("Getter value :", double)
  }, [])

  return <></>
}`}
                </CClipboard>
              </section>

              <hr className="divider" />

              <section id="get_state">
                <h5 id="f-getstate">f. getState</h5>
                <p>Below is an example of store that we will use.</p>
                <CClipboard className="lang-typescript">
                  {`import { createModule } from "react-reex"

const counterStore = createModule({
  state() {
    return {
      count: 0,
    }
  },
  getters: {
    double() {
      return this.count * 2
    },
  },
  actions: {
    increment() {
      this.commit("setCount", 1)
    },
  },
  mutations: {
    setCount(value) {
      this.count = value
    },
  },
})

export default counterStore`}
                </CClipboard>

                <CClipboard>
                  {`import { useEffect } from "react"
import store from "../store"

function MyComponent() {
  useEffect(() => {
    const count = store.getState("count")
    console.log("count value :", count)
  }, [])

  return <></>
}`}
                </CClipboard>
              </section>

              <hr className="divider" />

              <section id="use_reex_action">
                <h5 id="g-usereexaction">g. useReexAction</h5>
                <p>Below is an example of store that we will use.</p>

                <CClipboard className="lang-typescript">
                  {`import { createModule } from "react-reex"

const counterStore = createModule({
  state() {
    ...
  },
  getters: {
    ...
  },
  actions: {
    async getMessage() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({ message: 'done' });
        }, 2000)
      });
    },
  },
  mutations: {
    ...
  },
})

export default counterStore`}
                </CClipboard>
                <CClipboard>
                  {`import { useEffect } from "react"
import store from "../store"

function MyComponent() {
  const { data, fetcher, loading } = useReexAction("counter/getMessage")
  useEffect(() => {
    console.log("// --- //", loading)
  }, [loading])
  return (
    <div>
      {data && data.message && <span>{data.message}</span>}
      <button onClick={fetcher}>Start</button>
    </div>
  )
}`}
                </CClipboard>
              </section>

              <hr className="divider" />

              <section id="subscribe">
                <h5 id="h-subscribe">h. subscribe</h5>
                <p>Below is an example of store that we will use.</p>

                <CClipboard className="lang-typescript">
                  {`import { createModule } from "react-reex"

const counterStore = createModule({
  state() {
    return {
      count: 0,
    }
  },
  getters: {
    double() {
      return this.count * 2
    },
  },
  actions: {
    increment() {
      this.count++
    },
  },
})

export default counterStore`}
                </CClipboard>
                <CClipboard>
                  {`import store from "../store"

function CounterSubscribe() {
  store.subscribe("counter/count", function ({ state }) {
    console.log("Count updated", state.count)
  })

  return <></>
}`}
                </CClipboard>
              </section>
            </section>

            <hr className="divider" />

            <section id="store_persistent">
              <h3 id="8-store-persistent">8. Store Persistent</h3>
              <section id="store_persistent_all">
                <h5 id="a-all-stores">a. All stores</h5>
                <p>
                  In{" "}
                  <em>
                    <code>/store/index.ts</code>
                  </em>
                </p>
                <CClipboard>
                  {`import { createStore } from "react-reex"
import counterStore from "./counter"
// import orderStore from "./order"

const store = createStore({
  modules: {
    counterStore,
    // orderStore
  },
  created() {
    console.log("created global")
  },
  before(data) {
    console.log("before global", data)
  },
  handler(state) {
    console.log("handler global", state)
  },
})

// Add this
store.enablePersistStore({
  setItem(d, v: any) {
    localStorage.setItem(d, JSON.stringify(v))
  },
  getItem(d) {
    return JSON.parse(localStorage.getItem(d) as string)
  },
  removeItem(d) {
    return localStorage.removeItem(d)
  },
})

export const { useReexState, useReexGetter, useReexModule, useReexAction } = store

export default store`}
                </CClipboard>
              </section>

              <hr className="divider" />

              <section id="store_persistent_specific">
                <h5 id="b-specific-store">b. Specific store</h5>
                <p>
                  For example: In{" "}
                  <em>
                    <code>/store/counter</code>
                  </em>
                </p>
                <CClipboard className="lang-typescript">
                  {`import { createModule } from "react-reex"

const counterStore = createModule({
  state() {
    return {
      count: 0,
    }
  },
  ...
})

// Add this
counterStore.enablePersistStore({
  setItem (d, v: any) {
    localStorage.setItem(d, JSON.stringify(v))
  },
  getItem (d) {
    return JSON.parse(localStorage.getItem(d) as string)
  },
  removeItem (d) {
    return localStorage.removeItem(d)
  },
})

export default counterStore`}
                </CClipboard>
              </section>
            </section>

            <hr className="divider" />

            <section id="structure">
              <h2 id="9-module-structure">9. Module structure</h2>
              <p>
                All files with suffix <code>/(\*?\.store\.(js|ts|jsx|tsx))$/</code> in{" "}
                <em>
                  <code>src</code>
                </em>{" "}
                folder will consider as store module and will combine with the global store.
              </p>
              <CClipboard>
                {`- (root folder)
  - package.json
  - public
  - src
    - store
      - counter
        - index.ts
      - user
        - index.ts
      - index.ts
    - modules
      - home
        - page.tsx
        - home.store.ts
      - profile
        - page.tsx
        - profile.store.ts
`}
              </CClipboard>
              <p>
                In{" "}
                <em>
                  <code>src/modules/home/home.store.ts</code>
                </em>
              </p>
              <CClipboard className="lang-typescript">
                {`import { createModule } from "../reex";

const homeStore = createModule({
  name: "home",
  state: {
    nbr: 0,
  },
  getters: {
    double() {
      return this.nbr * 2;
    },
  },
  actions: {
    increment() {
      this.nbr++;
    },
  },
  mutations: {
    setCount(v: number) {
      this.nbr = v;
    }
  },
});

export default homeStore;`}
              </CClipboard>
            </section>

            <hr className="divider" />

            <section id="issues">
              <h2>Issues</h2>
              <p className="text-4">A Issues is a list of bugs and answers on a particular topic.</p>

              <AppIssueContextProvider>
                <ChatCollapse />
              </AppIssueContextProvider>
            </section>

            <hr className="divider" />
          </div>
        </div>
      </div>

      <footer id="footer" className="section bg-dark footer-text-light">
        <div className="container">
          <ul className="social-icons social-icons-lg social-icons-muted justify-content-center mb-3">
            <li>
              <a data-toggle="tooltip" href="#" target="_blank" title="" data-original-title="Dribbble">
                <i className="fab fa-dribbble"></i>
              </a>
            </li>
            <li>
              <a data-toggle="tooltip" href="#" target="_blank" title="" data-original-title="GitHub">
                <i className="fab fa-github"></i>
              </a>
            </li>
          </ul>
          <p className="text-2 text-center mb-0">
            Design &amp; Develop by{" "}
            <a className="btn-link" target="_blank" href="https://nosytech.fr">
              Hery John
            </a>
            .
          </p>
        </div>
      </footer>
    </>
  );
}
